import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "../DataTable";
import Loading from "../Loading";
import { useOrderList } from "./Hooks";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useSelector } from "react-redux";
import ReserveItem from "../../../../App/Panel/components/reserveItem";
import PanelListItemHeader from "../../../../App/Panel/components/PanelListItem/PanelListItemHeader";
import { Day, ToDateJalali, ToTimeJalali } from "../../Function";
import { weekdays } from "jalali-moment";
import { BsFilter } from "react-icons/bs";
import { daysToWeeks, getWeek } from "date-fns";
import TableSearch from "../DataTable/TableSearch";
import { RtlMui } from "../../../../App/component/rtlMui";

const OrderList = ({ role = false, short = false, isApp }) => {
  const { user } = useSelector(state => state);
  const { renderHeaders, data, loading, getData, searchHandler, pageHandler, sortHandler, filter, nextLoading, setFilter } = useOrderList(role, isApp);
  const [filterList, setFilterList] = useState({ show: false, fName: 1 })
  const [reverseData, SetReverseData] = useState(false)

  useEffect(() => {
    getData({ app: isApp });
    // getData();
  }, []);

  const navigate = useNavigate();
  const renderLinks = () => {
    switch (user.role) {
      case "owner":
      case "supporter":
      case "financial":
      case "contentmaker":
      case "user":
        return [
          {
            function: selected => {
              navigate(
                Checkroutedeatils() +
                data.data.filter(order => order.id == selected[0])[0]
                  .trackingcodeorder
                , {
                  state: {
                    role: "user"
                  }
                }
              );
            },
            color: "warning text-white",
            size: "col-md-2",
            html: "جزییات",
            // main: true,
            type: "show",
          },
          {
            size: "col-6",
            selected: true,
            typeLink: "div",
            html: (
              <FormControl fullWidth size="small">
                <InputLabel id="demo-multiple-name-label">نوع سفارش</InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  onChange={e => {
                    sortHandler("model_order", e.target.value);
                  }}
                  label={"مرتب شدن بر اساس"}
                  selected={filter["model_order"]}
                >
                  <MenuItem value={"reserve"}>رزرواسیون</MenuItem>
                  <MenuItem value={"joinclass"}>خرید کلاس</MenuItem>
                  <MenuItem value={"walletsharge"}>شارژ کیف پول</MenuItem>
                  <MenuItem value={"contractual_reservation"}>
                    رزرو قراردادی
                  </MenuItem>
                  <MenuItem value={"contractual_reservation_installments"}>
                    رزرو قراردادی پرداخت ماهیانه
                  </MenuItem>
                </Select>
              </FormControl>
            ),
          },
          {
            size: "col-6",
            selected: true,
            typeLink: "div",
            html: (
              <FormControl fullWidth size="small">
                <InputLabel id="demo-multiple-name-label">
                  نوع پرداخت
                </InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  onChange={e => {
                    sortHandler("type_payment", e.target.value);
                  }}
                  label={"مرتب شدن بر اساس"}
                  selected={filter["type_payment"]}
                >
                  <MenuItem value={"gateway"}>آنلاین</MenuItem>
                  <MenuItem value={"wallet"}>کیف پول</MenuItem>
                  <MenuItem value={"others"}>پرداخت نقدی</MenuItem>
                </Select>
              </FormControl>
            ),
          },
        ];
      default:
        return [
          {
            function: selected => {
              navigate(
                Checkroutedeatils() +
                data.data.filter(order => order.id == selected[0])[0]
                  .trackingcodeorder,
                { state: { role } }
              );
            },
            color: "warning text-white",
            size: "col-md-2",
            html: "جزییات",
            main: true,
            type: "show",
          },
          {
            size: "col-12 col-md-4",
            selected: true,
            typeLink: "div",
            html: (
              <FormControl fullWidth size="small">
                <InputLabel id="demo-multiple-name-label">
                  نوع پرداخت
                </InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  onChange={e => {
                    sortHandler("type_payment", e.target.value);
                  }}
                  label={"مرتب شدن بر اساس"}
                  selected={filter["type_payment"]}
                >
                  <MenuItem value={"gateway"}>آنلاین</MenuItem>
                  <MenuItem value={"wallet"}>کیف پول</MenuItem>
                  <MenuItem value={"others"}>پرداخت نقدی</MenuItem>
                </Select>
              </FormControl>
            ),
          },
        ];
    }
  };

  const Checkroutedeatils = () => {
    switch (user.role) {
      case "owner":
      case "supporter":
      case "financial":
      case "contentmaker":
        return "/Admin/OrderDetails/";
      default:
        return "/User/OrderDetails/";
    }
  };

  const checkStats = (data) => {
    switch (data) {
      case "peyed":
        return { text: "موفق", color: "#1BA462" }
      case "waittopay":
        return { text: "در انتظار پرداخت", color: "#F5BC1A" }
      case "null":
        return { text: "مشکل پرداخت", color: "#E42A3F" }
      case "payerror":
        return { text: "ناموفق", color: "#E42A3F" }
      case "used":
        return { text: "منقضی شده", color: "#F5BC1A" }
      case "refund":
        return { text: "استرداد شده", color: "#F5BC1A" }
      case "canceled":
        return { text: "لغو شده", color: "#F5BC1A" }
      default:
        return { text: "---", color: "#e1e1e1" }
    }
  }

  const checkDate = (data) => {
    // if (role) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const d = new Date(data);

    return {
      date: ToTimeJalali(data).split('-')[0],
      dayname: Day(days[d.getDay()]),
      time: ToTimeJalali(data).split('-')[1]
    }

    // }
    // else if (data.model_order == "reserve") {
    //   const allDate = data.reserve_product[0]?.reserve_time;
    //   return {
    //     date: allDate && ToDateJalali(allDate.date),
    //     dayname: allDate && Day(allDate.dayname),
    //     time: allDate && allDate.start + " - " + allDate.end
    //   }
    // }
    // else {
    //   const allDate = data.contract_product[0].reserve_time;
    //   return {
    //     date: allDate && ToDateJalali(allDate.date),
    //     dayname: allDate && Day(allDate.dayname),
    //     time: allDate && allDate.start + " - " + allDate.end
    //   }
    // }
  }

  const finalData = (data) => {
    if (reverseData) {
      return data.slice(0).reverse()
    }
    return data
  }

  return (
    <div>
      {isApp &&
        <>
          {/* نمایش فیلتر صعودی  و  نزولی برای  اپ */}
          <div className="my-4" style={{ color: reverseData ? "red" : "blue" }} onClick={() => SetReverseData(!reverseData)}>
            <BsFilter className={"ml-2"} size={24} />
            {reverseData ? "قدیمی‌ترین" : "جدیدترین"}
          </div>

          <div className="panelTabs">
            <RtlMui>
              <TableSearch className={"mb-2"} label={"جستجوی کاربر بر اساس نام، شماره تماس"} search={searchHandler} />
            </RtlMui>
          </div>
        </>
      }
      {isApp && (
        // نمایش لیست سفارش ها در اپ 
        !data?.data
          ? <Loading count="3" col={"12"} height="60px" />
          : data?.data.length > 0
            ?
            finalData(data?.data).map((item, index) => (
              <>
                <PanelListItemHeader key={index} titleDate={`${item.dayname} - ${item.date}`} />
                {item.data.map((item, index) => (
                  <ReserveItem key={index}
                    link={`/panel/OrderDetails/${item.trackingcodeorder}`}
                    statusColor={checkStats(item.status).color}
                    statusText={checkStats(item.status).text}
                    r1={item?.client?.fullname ? item.client.fullname : item?.item_reserve_product?.name}
                    r2={item?.client?.mobile}
                    r3={`کد پیگیری:${item.trackingcodeorder}`}
                    l1={item?.shiftTitle?.l1}
                    l2={item?.shiftTitle?.l2}
                  />
                ))}
              </>
            ))
            : <p className="text-center mt-3 bg-transparent">  سفارشی یافت نشد !   </p>
      )}

      {isApp && (data.next_page_url &&
        <button
          className="btn btn-primary mb-4 mt-3 w-100"
          onClick={() => pageHandler(+data.current_page + 1, 15, true)}>
          {nextLoading ? "در حال دریافت" : "نمایش بیشتر"}
        </button>
      )}



      {!isApp &&
        // نمایش لیست سفارش در جدول برای سایت 
        <DataTable
          loading={loading.list}
          heads={renderHeaders()["routes"]}
          list={data && data.data}
          bgTd={true}
          data={data}
          textEmpty="سفارشی یافت نشد"
          search={searchHandler}
          function={pageHandler}
          short={short}
          links={renderLinks()}
          header="لیست سفارشات"
        />
      }

      {isApp &&
        // نمایش فیلتر سفارش برای اپ 
        <>
          {/* دکمه فیلتر */}
          <div className={"filterBtn"} onClick={e => setFilterList({ ...filterList, show: true })}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 4.5H19V3.5H5V4.5ZM4.5 6.58579V5H3.5V6.58579H4.5ZM9.06065 11.3535L4.64645 6.93934L3.93934 7.64645L8.35355 12.0607L9.06065 11.3535ZM8.49999 12.4142V19.3063H9.49999V12.4142H8.49999ZM8.49999 19.3063C8.49999 19.9888 9.16869 20.4708 9.81622 20.255L9.49999 19.3063H8.49999ZM9.81622 20.255L14.8162 18.5883L14.5 17.6396L9.49999 19.3063L9.81622 20.255ZM14.8162 18.5883C15.2246 18.4522 15.5 18.0701 15.5 17.6396H14.5L14.8162 18.5883ZM15.5 17.6396V12.4142H14.5V17.6396H15.5ZM19.3536 6.93934L14.9393 11.3536L15.6464 12.0607L20.0607 7.64645L19.3536 6.93934ZM19.5 5V6.58579H20.5V5H19.5ZM20.0607 7.64645C20.342 7.36514 20.5 6.98361 20.5 6.58579H19.5C19.5 6.71839 19.4473 6.84557 19.3536 6.93934L20.0607 7.64645ZM15.5 12.4142C15.5 12.2816 15.5527 12.1544 15.6464 12.0607L14.9393 11.3536C14.658 11.6349 14.5 12.0164 14.5 12.4142H15.5ZM8.35355 12.0607C8.44731 12.1544 8.49999 12.2816 8.49999 12.4142H9.49999C9.49999 12.0164 9.34196 11.6349 9.06065 11.3535L8.35355 12.0607ZM3.5 6.58579C3.5 6.98361 3.65804 7.36514 3.93934 7.64645L4.64645 6.93934C4.55268 6.84557 4.5 6.71839 4.5 6.58579H3.5ZM19 4.5C19.2761 4.5 19.5 4.72386 19.5 5H20.5C20.5 4.17157 19.8284 3.5 19 3.5V4.5ZM5 3.5C4.17157 3.5 3.5 4.17157 3.5 5H4.5C4.5 4.72386 4.72386 4.5 5 4.5V3.5Z" fill="#333333" /></svg>
          </div>

          {/* باکس فیلتر  */}
          {filterList.show && <div className={"filterBox"} style={{ color: "#3F3E3E", fontSize: "13px", fontWeight: "600" }}>
            <div className="clickFilter"
              onClick={() => {
                setFilterList({ show: true, fName: 1 })
              }}>
              همه سفارشات
              {filterList.fName == 1 && <svg style={{ marginRight: "auto" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.5479 7.26647L20.1812 6.49252L19.4072 5.85928L17.8593 4.5928L17.0854 3.95956L16.4521 4.73352L8.66618 14.2496L6.2 12.4L5.4 11.8L4.8 12.6L3.6 14.2L3 15L3.8 15.6L8.56691 19.1752L9.33382 19.7504L9.94087 19.0084L19.5479 7.26647Z" stroke="#333333" strokeWidth="2" /></svg>}
            </div>

            <div className="clickFilter"
              onClick={() => {
                setFilterList({ show: true, fData: { status: 'peyed' }, fName: 2 });
              }}>
              سفارشات فعال
              {filterList.fName == 2 && <svg style={{ marginRight: "auto" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.5479 7.26647L20.1812 6.49252L19.4072 5.85928L17.8593 4.5928L17.0854 3.95956L16.4521 4.73352L8.66618 14.2496L6.2 12.4L5.4 11.8L4.8 12.6L3.6 14.2L3 15L3.8 15.6L8.56691 19.1752L9.33382 19.7504L9.94087 19.0084L19.5479 7.26647Z" stroke="#333333" strokeWidth="2" /></svg>}
            </div>

            <div className="clickFilter"
              onClick={() => {
                setFilterList({ show: true, fData: { status: 'used' }, fName: 3 });
              }}>
              سفارشات منقضی شده
              {filterList.fName == 3 && <svg style={{ marginRight: "auto" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.5479 7.26647L20.1812 6.49252L19.4072 5.85928L17.8593 4.5928L17.0854 3.95956L16.4521 4.73352L8.66618 14.2496L6.2 12.4L5.4 11.8L4.8 12.6L3.6 14.2L3 15L3.8 15.6L8.56691 19.1752L9.33382 19.7504L9.94087 19.0084L19.5479 7.26647Z" stroke="#333333" strokeWidth="2" /></svg>}
            </div>

            <div className="clickFilter"
              onClick={() => {
                setFilterList({ show: true, fData: { model_order: 'contractual_reservation' }, fName: 4 });
              }}>
              قراردادی ها
              {filterList.fName == 4 && <svg style={{ marginRight: "auto" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.5479 7.26647L20.1812 6.49252L19.4072 5.85928L17.8593 4.5928L17.0854 3.95956L16.4521 4.73352L8.66618 14.2496L6.2 12.4L5.4 11.8L4.8 12.6L3.6 14.2L3 15L3.8 15.6L8.56691 19.1752L9.33382 19.7504L9.94087 19.0084L19.5479 7.26647Z" stroke="#333333" strokeWidth="2" /></svg>}
            </div>

            <div className="clickFilter"
              onClick={() => {
                setFilterList({ show: true, fData: { model_order: 'contractual_reservation_installments', status: 'peyed' }, fName: 5 });
              }}>
              قراردادی ها - اقساطی (پرداخت شده)
              {filterList.fName == 5 && <svg style={{ marginRight: "auto" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.5479 7.26647L20.1812 6.49252L19.4072 5.85928L17.8593 4.5928L17.0854 3.95956L16.4521 4.73352L8.66618 14.2496L6.2 12.4L5.4 11.8L4.8 12.6L3.6 14.2L3 15L3.8 15.6L8.56691 19.1752L9.33382 19.7504L9.94087 19.0084L19.5479 7.26647Z" stroke="#333333" strokeWidth="2" /></svg>}
            </div>

            <div className="clickFilter"
              onClick={() => {
                setFilterList({ show: true, fData: { model_order: 'contractual_reservation_installments', status: 'waittopay' }, fName: 6 });
              }}>
              قراردادی ها - اقساطی (در انتظار پرداخت)
              {filterList.fName == 6 && <svg style={{ marginRight: "auto" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.5479 7.26647L20.1812 6.49252L19.4072 5.85928L17.8593 4.5928L17.0854 3.95956L16.4521 4.73352L8.66618 14.2496L6.2 12.4L5.4 11.8L4.8 12.6L3.6 14.2L3 15L3.8 15.6L8.56691 19.1752L9.33382 19.7504L9.94087 19.0084L19.5479 7.26647Z" stroke="#333333" strokeWidth="2" /></svg>}
            </div>

            <div className={"d-flex mt-auto filterBtnBox noneBefor"}>
              <button className="btn btnMain"
                onClick={e => {
                  setFilterList({ ...filterList, show: false })
                  getData({ ...filterList.fData, app: true })
                  setFilter({ ...filterList.fData })
                }}>
                اعمال فیلتر
              </button>
            </div>
          </div>
          }
        </>
      }


    </div >
  );
};

export default OrderList;
